<template>
  <div class="all-question-outer">
      <div class="sign">
          <div class="cancelSign" @click="cancelSign(questionData)">
              <img src="../../../../assets/cancelSign.png" alt="">
              <span>取消标记</span>
          </div>
          <div class="addSign" @click="addSign(questionData)">
              <img src="../../../../assets/addSign.png" alt="">
              <span>标记此题</span>
          </div>
      </div>
      <div class="question" v-if="questionData">
          <div class="questionTop">
              <span class="title">「填空题」</span>
              <span class="questionName">{{questionData.questionNumber}}.{{questionData.questionName}}</span>
          </div>
          <ul>
            <li v-for="item in questionData.blanks" :key="item.blank1Id">
                <span>{{item.blankId}}空答案为：</span>
                <a-textarea v-model="value[item.blankId-1]"  class="textarea"  auto-size @change="onChange(questionData)" disabled/>
            </li>
          </ul>
          <div :class="JSON.stringify(questionData.answer)===JSON.stringify(questionData.myAnswer)?'answer1':'answer2'">
              <li v-for="item in questionData.blanks.length" :key="item">
                 <span>填空{{item}}：正确答案为：{{questionData.answer[item-1]}}</span>
                 <span>你的答案：{{questionData.myAnswer[item-1]?questionData.myAnswer[item-1]:"未答"}}</span>
              </li>
          </div>
          <div class="ansAnalysis">
              答案解析：{{questionData.ansAnalysis}}
              <div class="ansAnalysisImg"><img :src="questionData.ansAnalysisImg" alt=""></div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
    name:"fillBlanks",
    props:['questionData'],
    data(){
        return{
            value: this.questionData.myAnswer,
        }
    },
    methods:{
        onChange(val) {
            val.isAnswer = true;
        },
        //取消标记
        cancelSign(val){
            val.isSign = false;
        },
        //标记此题
        addSign(val){
            val.isSign = true;
        }
    }

}
</script>

<style scoped>
.all-question-outer {
    width: 100%;
    height: calc(100% - 60px);
    padding: 20px 50px 30px 50px;
    overflow-y: auto;
}
.sign{
    height: 32px;
    margin-left: 500px;
}
.sign img{
    width: 18px;
    height: 20px;
}
.question .title{
    width: 371px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    line-height: 32px;
}
.question .questionName{
    width: 92px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #14202C;
    line-height: 32px;
}
.questionTop{
    padding: 15px 0 0;
}
li{
    margin-bottom: 20px;
}
li .textarea{
    width: 85%;
}
li span{
  line-height: 32px;
}
.answer1{
    background: #D7F3EA;
    margin-top: 15px;
    list-style: none;
}
.answer1 li{
    margin-bottom: 0px;
}

.answer1 span{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #32B387;
    line-height: 40px;
    margin-left: 18px;
    margin-right: 10px;
}
.answer2{
    background: #FAE7E6;
    margin-top: 15px;
    list-style: none;
}
.answer2 li{
    margin-bottom: 0px;
}
.answer2 span{
    width: 79px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #EA7E7B;
    line-height: 40px;
    margin-left: 18px;
    margin-right: 10px;
}
.answer2 span{
    width: 79px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #EA7E7B;
    line-height: 40px;
    margin-left: 18px;
    margin-right: 10px;
}
.ansAnalysis{
    margin-top: 21px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 22px;
    word-break:break-all;
    margin-bottom: 40px;
}
.ansAnalysisImg img{
    height: 364px;
    width: 100%;
    margin-top: 20px;
}

</style>